import {
    getMerchantTransSettings
  } from "../../services/MerchantTransSettingService";
  export const MERCHANT_TRANS_SETTINGS_LIST_INITIATED = "MERCHANT_TRANS_SETTINGS_LIST_INITIATED";
  export const MERCHANT_TRANS_SETTINGS_LIST_LOADED = "MERCHANT_TRANS_SETTINGS_LIST_LOADED";
  export const MERCHANT_TRANS_SETTINGS_FAILED = "MERCHANT_TRANS_SETTINGS_FAILED";
  
  export const loadMerchantTransSettings = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_TRANS_SETTINGS_LIST_INITIATED });
      getMerchantTransSettings(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_TRANS_SETTINGS_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_TRANS_SETTINGS_FAILED, payload: error.message });
        });
    };
  };